module.exports = __webpack_public_path__ + "static/san-antonio-f60fd30c36b6c9703335089562fde6fd.png";